/**
 * Scroll utilities to ensure proper page scrolling behavior
 */

/**
 * Resets scroll position to the top of the page
 * Uses multiple approaches to ensure maximum browser compatibility
 */
export const resetScroll = () => {
  // Method 1: Using window.scrollTo
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'instant'
  });
  
  // Method 2: Using documentElement.scrollTop
  if (document.documentElement) {
    document.documentElement.scrollTop = 0;
  }
  
  // Method 3: Using body.scrollTop (for older browsers)
  if (document.body) {
    document.body.scrollTop = 0;
  }
};

/**
 * Attempts to prevent scroll restoration
 * This is useful to prevent browsers from restoring previous scroll positions
 */
export const preventScrollRestoration = () => {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
}; 